<template>
  <div class="head__list">
    <template v-if="type === 1">
      <div class="head__list-item">纸样师：{{info. patternDesigner}}</div>
      <div class="head__list-item">放码：{{info.sizeGrad}}</div>
      <!-- <div class="head__list-item">工艺师：{{info.craftsman}}</div> -->
      <div class="head__list-item">审核：{{info.checkByName}}</div>
      <div class="head__list-item">日期：{{new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString('it-IT')}}</div>
    </template>
    <template v-if="type === 2">
      <div class="head__list-item">工艺师：{{info.craftsman}}</div>
      <div class="head__list-item">设计跟单：{{info.followOrderUserName}}</div>
      <div class="head__list-item">审核：{{info.checkByName}}</div>
      <div class="head__list-item">日期：{{new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString('it-IT')}}</div>
    </template>
  </div>
</template>

<script>
import { formatImgUrl } from "src/filter/modules/img";

export default {
  name: "print-foot",
  filters: {},
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    isWoollen: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 1
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "src/sass/index";
@import "src/sass/modules/mixin";
$_normal_font: 3.2mm;
$_title_font: 5mm;
$box_width: 190mm;
$box_height: 277mm;
$_black: #333;
// 标题部分

.head__list {
  font-size: $_normal_font;
  @include flex_center(space-around, center);
}
</style>
